import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TCcn } from '../../interfaces/tccn.model';
import { apiEndpoints } from '../../constants/api-endpoints';
import { HttpUtilityService } from '../http.utility.service';

@Injectable({ providedIn: 'root' })
export class CompanyCodeService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  getCompanies(): Observable<HttpResponse<any[]>> {
    return this.httpUtilityService.get<any[]>(apiEndpoints.companyList);
  }

  addCompanyCode(code: TCcn): Observable<HttpResponse<TCcn>> {
    return this.httpUtilityService.post<TCcn>(apiEndpoints.companyList, code);
  }

  deleteCompanyCode(id: number): Observable<HttpResponse<void>> {
    return this.httpUtilityService.delete<any>(apiEndpoints.companyList, id);
  }
}
